import { useParams } from 'react-router-dom';
import LeadDetail from '@/pages/LeadDetail';
import { useSyncIdQuery } from './useSyncIdQuery';

export default function MobileLeadDetailScreen() {
  const { id } = useParams();
  useSyncIdQuery(id);
  return <LeadDetail />;
}

